import axios from 'axios';
import { ApiKey as IApiKey } from 'api/api-keys';
import {
  getCurrentApiHost,
  API_NAMESPACE,
  API_VERSION,
} from 'config/environment';
import { ApiKey } from './api-key';
import { logger } from './logger';

let _apiKey: [number, string] | null;

interface PreviewApiKeyResponse {
  apiKey: string;
}

const savePreviewApiKey = async (projectId: number) => {
  if (_apiKey?.[0] === projectId) {
    return;
  }
  try {
    const {
      data: { apiKey },
    } = await axios.get<PreviewApiKeyResponse>(
      `${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}/projects/${projectId}/customer-access`,
      { headers: ApiKey.header() },
    );

    _apiKey = [projectId, apiKey];
  } catch (error) {
    logger.error('unable to get preview api key', { error });
    throw error;
  }
};

const saveLiveCpApiKey = async (projectId: number) => {
  if (_apiKey?.[0] === projectId) {
    return;
  }
  try {
    const apiKey = await axios.get<IApiKey>(
      `${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}/customer-portal-builder/bot-api-key/project/${projectId}`,
      { headers: ApiKey.header() },
    );

    _apiKey = [projectId, apiKey?.data?.apiKey ?? ''];
  } catch (error) {
    logger.error('unable to get live cp api key', { error });
    throw error;
  }
};

const isPreviewMode = async (): Promise<[true, number] | [false]> => {
  if (_apiKey != null) {
    return [true, _apiKey[0]];
  }
  const { pathname } = window.location;
  const { search } = window.location;
  const [, _projectId] = pathname.match(/\/projects\/(.*)\//) ?? [];
  const hasProjectId = typeof _projectId === 'string' && _projectId !== '';
  const projectId = parseInt(_projectId, 10);
  const customerPreview = /customer-preview=true/.test(search) && hasProjectId;

  const isLiveCustomerPortal = /live-customer-portal-preview/.test(pathname);

  if (isLiveCustomerPortal) {
    const match = pathname.match(/live-customer-portal-preview\/(\d+)/);

    const liveCpProjectId = parseInt(match?.[1] ?? '', 10);

    await saveLiveCpApiKey(liveCpProjectId);

    return [false];
  }

  if (!customerPreview) {
    _apiKey = null;

    return [false];
  }
  try {
    await savePreviewApiKey(projectId);

    return [true, projectId];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return [false];
  }
};

const header = (): Record<string, string> =>
  // eslint-disable-next-line @typescript-eslint/naming-convention
  _apiKey == null ? {} : { 'api-key': _apiKey[1] };

export const CustomerPreview = {
  header,
  isPreviewMode,
};
